export const RecurrencyPeriodsModel = {
    recurrency_period_id: 0,
    description: "",
    repetition_days: 0,
    repetition_count : 0
}